/* eslint-disable import/no-anonymous-default-export */
export default {
  addProject: "إضافة مشروع",
  editProject: "تحرير مشروع",
  viewProject: "عرض مشروع",
  projectIdHeading: "معرف المشروع",
  projectNameHeading: "اسم المشروع",
  taskCountHeading: "عدد المهام المخصصة",
  projectTitle: "مشروع",
};
